"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalContentResourceStencil = exports.externalContentResourceStencilDefinition = void 0;
const properties_1 = require("../properties");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'subheading',
            'teaser',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'url',
                    'featured-media',
                    'featured-video',
                    'geolocation',
                    'logos',
                ],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'standalone',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
exports.externalContentResourceStencilDefinition = {
    view: {
        label: 'External content resource',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'subheading',
                    'teaser',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'url',
                            'featured-media',
                            'featured-video',
                            'geolocation',
                            'logos',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: { hasFeatureCardPreview: true },
    },
    content: {
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: {
            ...properties_1.urlPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'pattern',
                    argument: '(https?://.*)?',
                },
            ],
        },
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'external-content-resource',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
};
const isExternalContentResourceStencil = (stencil) => {
    return stencil.name === exports.externalContentResourceStencilDefinition.name;
};
exports.isExternalContentResourceStencil = isExternalContentResourceStencil;
//# sourceMappingURL=data:application/json;base64,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